export enum UserRole {
  TENANT = "TENANT",
  ADMIN = "ADMIN",
  OWNER = "OWNER",
  STAFF = "STAFF",
  UNASSIGNED = "UNASSIGNED",
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
  SUSPENDED = "SUSPENDED",
}

export interface User {
  userUUID: string;
  firstName?: string;
  lastName?: string;
  email: string;
  phoneNumber?: string;
  role: UserRole;
  status: UserStatus;
  birthDate?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  imageGoogleUrl?: string;
  googleId?: string;
  socialProvider?: boolean;
  providerName?: string;
}

export const USER_ROLE_NAMES: Record<UserRole, string> = {
  [UserRole.TENANT]:"users.roles.TENANT",
  [UserRole.ADMIN]:"users.roles.ADMIN",
  [UserRole.OWNER]:"users.roles.OWNER",
  [UserRole.STAFF]:"users.roles.STAFF",
  [UserRole.UNASSIGNED]:"users.roles.UNASSIGNED",
};

export const USER_STATUS_NAMES: Record<UserStatus, string> = {
  [UserStatus.ACTIVE]:"users.statuses.ACTIVE",
  [UserStatus.INACTIVE]:"users.statuses.INACTIVE",
  [UserStatus.PENDING]:"users.statuses.PENDING",
  [UserStatus.SUSPENDED]:"users.statuses.SUSPENDED",
}; 